import React, { useEffect, useState, useContext } from "react";
import SellerSidebar from "../../../navigation/sellerNavigation.js";
import { getData } from "../../../fetchRoutes/getData.js";
import PropertyCard from "../../../utility/propertyCard.js";
import SellerMobileSidebar from "../../../navigation/sellerMobileNavigation";
import { DeviceContext } from "../../../context/deviceContext";

export default function AdminPropertiesContainer() {

    const myPropertiesUrl = process.env.REACT_APP_GET_PROPERTIES;

    const {isMobile}= useContext(DeviceContext);
    

    const [properties, setProperties] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // eslint-disable-next-line
    const [selectedProperty, setSelectedProperty] = useState(null);

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const propertiesPerPage =  isMobile ? 2 : 8;

    // Fetch properties
    useEffect(() => {
        async function fetchProperties() {
            try {
                const response = await getData(myPropertiesUrl);
                if (response.status === 'Success') {
                    setProperties(response.data);
               
                }
            } catch {
                setError('Failed to fetch properties');
            } finally {
                setLoading(false);
            }
        }
        fetchProperties();
    }, [myPropertiesUrl]);

    // Handle auction form popup
    const handleAuctionClick = (property) => {
        setSelectedProperty(property);
    };

    // Handle auction closure
    const handleAuctionClose = (auctionId) => {
        setProperties((prev) =>
          prev.map((prop) =>
            prop.auction?._id === auctionId
              ? { ...prop, auction: { ...prop.auction, status: 'close' } }
              : prop
          )
        );
    };
      
    // Handle delete property
    const handleDeleteProperty = (deletedPropertyId) => {
        setProperties((prev) => prev.filter((prop) => prop._id !== deletedPropertyId));
      };
      
  
    // Pagination
    const indexOfLastProperty = currentPage * propertiesPerPage;
    const indexOfFirstProperty = indexOfLastProperty - propertiesPerPage;
    const currentProperties = properties.slice(indexOfFirstProperty, indexOfLastProperty);

    const totalPages = Math.ceil(properties.length / propertiesPerPage);

    return (
        <main className="sellerDashboard myPropertiesDashboard">
            {isMobile ? <SellerMobileSidebar/> :<SellerSidebar />}
            <div className="container">
                <h1 className="containerTitle">DELETE PROPERTIES/CLOSE AUCTION</h1>
                <div className="propertyList">
                    {isLoading ? (
                        <p className="loadingText">Loading properties...</p>
                    ) : currentProperties.length > 0 ? (
                        currentProperties.map((property) => (
                            <PropertyCard
                                key={property._id}
                                property={property}
                                onButtonClick={handleAuctionClick}
                                buttonLabel={
                                    property.auction
                                      ? property.auction.status === 'closed'
                                        ? "Already Closed"
                                        : property.auction.status === 'scheduled'
                                          ? "Scheduled"
                                          : property.auction.status === 'open'
                                            ? "Close Auction"
                                            : "Close Auction"
                                      : "Not on Auction"
                                }
                                isAuctionDisabled={!property.auction || property.auction.status === 'closed' || property.auction.status === 'scheduled'}
                                thirdLabel='Delete Property'
                                closeClass='closeAuction'
                                onAuctionClose={handleAuctionClose}
                                onDeleteProperty={handleDeleteProperty}
                                  
                            />
                        ))
                    ) : (
                        <p className="noPropertiesText">No properties found.</p>
                    )}
                    {error && <p className="errorMessage">{error}</p>}
                </div>

                {/* Pagination Controls */}
                {totalPages > 1 && (
                    <div className="pagination">
                        <button
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                            disabled={currentPage === 1}
                            className={`btnPagination ${currentPage === 1 ? 'disabled' : ''}`}
                        >
                            Previous
                        </button>

                        <span className="pageInfo">Page {currentPage} of {totalPages}</span>

                        <button
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                            disabled={currentPage === totalPages}
                            className={`btnPagination ${currentPage === totalPages ? 'disabled' : ''}`}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>

            
        </main>
    );
}
